import { render, staticRenderFns } from "./ApplicationTableItem.vue?vue&type=template&id=16ffac50&scoped=true"
import script from "./ApplicationTableItem.vue?vue&type=script&lang=js"
export * from "./ApplicationTableItem.vue?vue&type=script&lang=js"
import style0 from "./ApplicationTableItem.vue?vue&type=style&index=0&id=16ffac50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ffac50",
  null
  
)

export default component.exports